var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4209 3.27198H30.4399L16.9249 43.3155C16.786 43.727 16.5215 44.0845 16.1688 44.3378C15.816 44.5911 15.3927 44.7274 14.9584 44.7275H4.8264C4.49736 44.7275 4.17303 44.6492 3.88025 44.499C3.58748 44.3489 3.33467 44.1311 3.14274 43.8638C2.95081 43.5966 2.82528 43.2874 2.77653 42.962C2.72778 42.6366 2.75722 42.3043 2.8624 41.9925L15.4539 4.68398C15.5928 4.27234 15.8572 3.91462 16.2101 3.66122C16.563 3.40782 16.9865 3.27151 17.4209 3.27148V3.27198Z",
    fill: "url(#paint0_linear_5039_12122)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3395 30.1304H15.6945C15.5025 30.1302 15.315 30.1878 15.1563 30.2957C14.9975 30.4036 14.875 30.5568 14.8045 30.7353C14.7341 30.9139 14.7191 31.1095 14.7615 31.2967C14.8038 31.4839 14.9016 31.654 15.042 31.7849L28.308 44.1669C28.6942 44.5272 29.2028 44.7275 29.731 44.7274H41.421L36.3395 30.1304Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4209 3.27199C16.9818 3.2703 16.5536 3.40909 16.1989 3.66807C15.8442 3.92705 15.5816 4.29266 15.4494 4.71149L2.87794 41.9585C2.76568 42.2714 2.73044 42.6067 2.77519 42.9362C2.81995 43.2656 2.94338 43.5794 3.13506 43.851C3.32673 44.1226 3.581 44.3441 3.87637 44.4966C4.17174 44.6492 4.4995 44.7284 4.83194 44.7275H15.2254C15.6125 44.6583 15.9743 44.4876 16.2739 44.2329C16.5734 43.9781 16.8 43.6484 16.9304 43.2775L19.4374 35.889L28.3924 44.2415C28.7677 44.5519 29.2385 44.7235 29.7254 44.7275H41.3719L36.2639 30.1305L21.3734 30.134L30.4869 3.27199H17.4209Z",
    fill: "url(#paint1_linear_5039_12122)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0494 4.68197C33.9108 4.27099 33.6467 3.91387 33.2943 3.66091C32.942 3.40796 32.5192 3.27192 32.0854 3.27197H17.5759C18.0097 3.272 18.4324 3.40806 18.7848 3.661C19.1371 3.91395 19.4012 4.27103 19.5399 4.68197L32.1319 41.992C32.2372 42.3038 32.2667 42.6362 32.218 42.9617C32.1693 43.2872 32.0438 43.5965 31.8518 43.8638C31.6599 44.1312 31.4071 44.349 31.1143 44.4993C30.8214 44.6496 30.4971 44.728 30.1679 44.728H44.6779C45.007 44.7279 45.3313 44.6494 45.6241 44.4991C45.9169 44.3488 46.1696 44.131 46.3615 43.8636C46.5534 43.5963 46.6788 43.2871 46.7275 42.9616C46.7762 42.6362 46.7467 42.3038 46.6414 41.992L34.0494 4.68197Z",
    fill: "url(#paint2_linear_5039_12122)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5039_12122",
    x1: 22.1659,
    y1: 6.34398,
    x2: 8.6454,
    y2: 46.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5039_12122",
    x1: 26.3894,
    y1: 24.9585,
    x2: 23.2619,
    y2: 26.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5039_12122",
    x1: 24.6694,
    y1: 5.17897,
    x2: 39.5109,
    y2: 44.7195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.db218e1e.svg";
export { ForwardRef as ReactComponent };